import HeroReferrals from './HeroReferrals';

export default HeroReferrals;
